var config = {
    cookieName : 'VHD',
    apiDomain : 'http://vhdapi.empowerllp.com',
    mediaDomain : 'http://vhdapi.empowerllp.com',
    liveDomain : 'http://vhd.empowerllp.com'
  };
module.exports = config;


// WEBPACK FOOTER //
// ./src/config/config.js